/**
 * Marca CAINT: escudo (3 linhas de defesa) + barras ascendentes (maturidade
 * 0→4) + ponto de excelência no acento. Herda a paleta ativa via CSS vars.
 */

export interface LogoProps {
  size?: number;
  variant?: "primary" | "reverse";
}

const BARS: readonly [number, number][] = [
  [13.6, 6.5],
  [19.1, 9.5],
  [24.6, 12.5],
  [30.1, 15.5],
];
const OPS = [0.55, 0.72, 0.86, 1];
const TOPO: readonly [number, number] = [30.1, 15.5]; // barra do topo = ponto de excelência

export function Logo({ size = 32, variant = "primary" }: LogoProps) {
  const shieldFill = variant === "reverse" ? "url(#mcg)" : "var(--teal-600)";
  const topo = TOPO;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" role="img" aria-label="CAINT">
      <defs>
        <linearGradient id="mcg" x1="10" y1="6" x2="38" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--teal-400)" />
          <stop offset="1" stopColor="var(--teal-600)" />
        </linearGradient>
      </defs>
      <path d="M10 8 Q10 6 12 6 L36 6 Q38 6 38 8 L38 26 Q38 34.5 24 42 Q10 34.5 10 26 Z" fill={shieldFill} />
      {BARS.map((b, i) => (
        <rect
          key={b[0]}
          x={b[0]}
          y={31 - b[1]}
          width="4.4"
          height={b[1]}
          rx="1.4"
          fill="#fff"
          opacity={OPS[i]}
        />
      ))}
      <circle
        cx={topo[0] + 2.2}
        cy={31 - topo[1]}
        r="2.5"
        fill="var(--coral-500)"
        stroke={variant === "reverse" ? "var(--teal-600)" : shieldFill}
        strokeWidth="0.8"
      />
    </svg>
  );
}
